import { render, staticRenderFns } from "./public-holiday-component.vue?vue&type=template&id=2ee84140&scoped=true"
import script from "./public-holiday-component.vue?vue&type=script&lang=js"
export * from "./public-holiday-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee84140",
  null
  
)

export default component.exports